import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConsentService } from './consent.service';

/**
 * First-party, cookieless page-view tracking. Hits are sent ONLY after the
 * visitor has granted cookie consent (gated on ConsentService). No IP/PII is
 * collected. When consent is granted mid-session, the pending page is sent.
 */
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private base = environment.apiBaseUrl + '/public';
  private lastPath = '';
  private started = false;

  constructor(private http: HttpClient, private consent: ConsentService) {
    // Send the current page as soon as consent flips to granted.
    this.consent.consent$.subscribe((state) => {
      if (state === 'granted' && this.lastPath) this.send(this.lastPath);
    });
  }

  /** Call on each route change; records the page only if consent is granted. */
  trackPageView(path: string): void {
    this.lastPath = path || '/';
    if (this.consent.granted) this.send(this.lastPath);
  }

  private send(path: string): void {
    let referrer = '';
    try {
      if (typeof document !== 'undefined' && document.referrer) {
        const u = new URL(document.referrer);
        if (u.host && u.host !== location.host) referrer = u.host;
      }
    } catch { /* ignore malformed referrer */ }

    this.http.post(`${this.base}/pageview`, { path, referrer }).subscribe({
      next: () => {},
      error: () => { /* analytics is best-effort; never disrupt the page */ }
    });
  }
}
